<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<div class="padding-top-20 padding-bottom-50">
			<div class="container">
				<div class="page-content">
					<component :is="componentInstance" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'

export default {
	name: 'ExecutiveSummary',
	components: {
		PageTitle,
	},
	mixins: [PageInfo],
	computed: {
		componentInstance() {
			const componentName = this.$store.getters.locale
				? 'ExecutiveSummary' + this.$store.getters.locale.toUpperCase()
				: 'ExecutiveSummaryIT'
			return () => import(`@/views/service/lang/${componentName}`)
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/service/ExecutiveSummary.vue